export const compLocalStorage = 'IbnAlNafis_company';
